import React from 'react';
import { Agent } from '@marageti/z4-sdk/lib/people';
import { ContextMenuComplete, useCurrentTime } from '@marageti/z4-lib';
import UserProfileDetails from './UserProfileDetails';
import {
  getPhoneNumber,
  getRoleDisplayName,
  formatTimeWithTimeZoneName,
} from '../../../utils/helpers';

export type ContextMenuCompleteProps = Parameters<
  typeof ContextMenuComplete
>[0];

type UserProfileDetailsWrapperProps = {
  agent: Agent;
  contextMenuProps?: ContextMenuCompleteProps;
};

const UserProfileDetailsWrapper = ({
  agent,
  contextMenuProps,
}: UserProfileDetailsWrapperProps) => {
  const {
    title, fullName, userInfo, email, timeZone,
  } = agent || {};

  const [time] = useCurrentTime(timeZone?.name);

  const items = [
    {
      title: 'Name',
      content: fullName,
      action: contextMenuProps && (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <ContextMenuComplete {...contextMenuProps} />
      ),
    },
    {
      title: 'Title',
      content: title,
    },
    {
      title: 'Role',
      content: getRoleDisplayName(userInfo![0].roles),
    },
    {
      title: 'Email',
      content: email,
    },
    {
      title: 'Phone',
      content: getPhoneNumber(agent),
    },
    {
      title: 'Timezone',
      content: timeZone ? formatTimeWithTimeZoneName(timeZone, time) : '-',
    },
  ];

  return <UserProfileDetails items={items} />;
};

export default UserProfileDetailsWrapper;
